// extracted by mini-css-extract-plugin
var _1 = "ContentMapColumnHeader-module__animatedBackground--oK2En";
var _2 = "ContentMapColumnHeader-module__badgeContainer--AcSJh";
var _3 = "ContentMapColumnHeader-module__container--ADR2w";
var _4 = "ContentMapColumnHeader-module__name--MFLfA";
export { _1 as "animatedBackground", _2 as "badgeContainer", _3 as "container", _4 as "name" }
